"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.String = void 0;
const IonTypes_1 = require("../IonTypes");
const FromJsConstructor_1 = require("./FromJsConstructor");
const NativeJsTypes_1 = require("./NativeJsTypes");
const Value_1 = require("./Value");
const _fromJsConstructor = new FromJsConstructor_1.FromJsConstructorBuilder()
    .withPrimitives(FromJsConstructor_1.Primitives.String)
    .withClassesToUnbox(NativeJsTypes_1._NativeJsString)
    .build();
/**
 * Represents a string[1] value in an Ion stream.
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#string
 */
class String extends (0, Value_1.Value)(NativeJsTypes_1._NativeJsString, IonTypes_1.IonTypes.STRING, _fromJsConstructor) {
    /**
     * Constructor.
     * @param text          The text value to represent as a string.
     * @param annotations   An optional array of strings to associate with the provided text.
     */
    constructor(text, annotations = []) {
        super(text);
        this._setAnnotations(annotations);
    }
    stringValue() {
        return this.toString();
    }
    writeTo(writer) {
        writer.setAnnotations(this.getAnnotations());
        writer.writeString(this.stringValue());
    }
    _valueEquals(other, options = {
        epsilon: null,
        ignoreAnnotations: false,
        ignoreTimestampPrecision: false,
        onlyCompareIon: true,
    }) {
        let isSupportedType = false;
        let valueToCompare = null;
        // if the provided value is an ion.dom.String instance.
        if (other instanceof String) {
            isSupportedType = true;
            valueToCompare = other.stringValue();
        }
        else if (!options.onlyCompareIon) {
            // We will consider other String-ish types
            if (typeof other === "string" || other instanceof NativeJsTypes_1._NativeJsString) {
                isSupportedType = true;
                valueToCompare = other.valueOf();
            }
        }
        if (!isSupportedType) {
            return false;
        }
        return this.compareValue(valueToCompare) === 0;
    }
    compareValue(expectedValue) {
        return this.stringValue().localeCompare(expectedValue);
    }
}
exports.String = String;
